module.exports = __webpack_public_path__ + "img/detail2.9765be10.png";